<template>
  <div class="content">
    <!-- 顶部导航栏 -->
    <div class="header">
      <van-nav-bar
        title="我的订单"
        left-arrow
        :fixed="true"
        :placeholder="true"
        @click-left="$router.push('/personalCenter')"
      />
    </div>
    <!-- 列表 -->
    <div class="center">
      <van-tabs
        v-model="active"
        title-active-color="red"
        :immediate-check="false"
        :sticky="true"
        offset-top="1.22667rem"
        @change="onChange"
        
      >
        <van-tab title="全部">
          <AllOrders :active="'0,1,3,5,6,7,8,9,10,11'" v-if="update"></AllOrders>
          </van-tab>
        <van-tab title="待付款"><AllOrders :active="0"  v-if="update"></AllOrders></van-tab>
        <van-tab title="待发货"><AllOrders :active="1" v-if="update"></AllOrders></van-tab>
        <van-tab title="待收货"><AllOrders :active="3" v-if="update"></AllOrders></van-tab>
        <van-tab title="已完成"><AllOrders :active="5" v-if="update"></AllOrders></van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import AllOrders from "../../components/myOrder2/allOrders.vue";
export default {
  components: {
    AllOrders,
  },
  data() {
    return {
      active: 0,
      update: true,
    };
  },
  mounted() {
    this.updateType();
  },
  methods: {
    updateType() {
      let type = location.search;
      //通过拿到的值不同，更改activeName的值
      if (type === "?type=1") {
        this.active = 0;
      } else if (type === "?type=2") {
        this.active = 1;
      } else if (type === "?type=3") {
        this.active = 2;
      } else if (type === "?type=4") {
        this.active = 3;
      } else if (type === "?type=5") {
        this.active = 4;
      }
    },
    onChange(e) {
      let queryType;
      if (e == 0) {
        queryType = 1;
        // 移除组件
        this.update = false;
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true;
        });
      } else if (e == 1) {
        queryType = 2;
         // 移除组件
        this.update = false;
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true;
        });
      } else if (e == 2) {
        queryType = 3;
         // 移除组件
        this.update = false;
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true;
        });
      } else if (e == 3) {
        queryType = 4;
         // 移除组件
        this.update = false;
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true;
        });
      } else if (e == 4) {
        queryType = 5;
         // 移除组件
        this.update = false;
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true;
        });
      }
      this.$router.replace({
        path: "/myOrder2",
        query: {
          type: queryType || 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  min-height: 100%;
  background-color: #E8E8E8;
  // background-color: #fafafa;
  .header {
    /deep/.van-icon-arrow-left::before {
      font-size: 0.533333rem;
      color: black;
    }
    /deep/.van-nav-bar__title {
      font-weight: 600;
    }
  }
}
</style>
